import { Filesystem as FileSystemPlugin, Directory } from "@capacitor/filesystem";
import { Logger } from "@core/helpers/logger.helpers";

export class Filesystem {
  /**
   * Returns the Capacitor Filesystem plugin instance
   * @readonly
   */
  static get plugin() {
    return FileSystemPlugin;
  }

  /**
   * Write a file to disk in the specified location on device
   // https://capacitorjs.com/docs/v2/apis/filesystem#writefile
   * @returns {Promise<FileWriteResult>} DeviceInfo
   */
  static async writeFile({ path, data }) {
    try {
      return await Filesystem.plugin.writeFile({
        path,
        data,
        directory: Directory.Documents,
      });
    } catch (error) {
      Logger.error("### Filesystem - writeFile - error", error);
      throw error;
    }
  }
}
